const AUDIENCE_KEY = "cmAudience";

export const AUDIENCE = {
  SEEKER: "seeker",
  EMPLOYER: "employer",
};

export function getAudience() {
  const value = window.sessionStorage.getItem(AUDIENCE_KEY);
  if (value === AUDIENCE.SEEKER || value === AUDIENCE.EMPLOYER) {
    return value;
  }
  return null;
}

export function setAudience(audience) {
  if (audience !== AUDIENCE.SEEKER && audience !== AUDIENCE.EMPLOYER) {
    return;
  }
  window.sessionStorage.setItem(AUDIENCE_KEY, audience);
}

export function clearAudience() {
  window.sessionStorage.removeItem(AUDIENCE_KEY);
}

export function audienceHomePath(audience) {
  return audience === AUDIENCE.EMPLOYER ? "/for-employers" : "/for-seekers";
}
